import Tab from 'core/components/Tab';
import { useFiltersFromUrl } from 'core/hooks/useFiltersFromUrl';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { changeQuery, isMobile } from 'core/utils';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import NotificationsContent from './tabs-content/NotificationsContent';
import SubscriptionsContent from './tabs-content/SubscriptionsContent';
import c from 'classnames';

type ISubscriptionsTab = 'none' | 'notifications' | 'subscriptions';

type ISubscriptionsProps = {
    isShowcase: boolean;
};

const Subscriptions: React.FC<ISubscriptionsProps & WithStyles<typeof styles>> = ({ classes, isShowcase }) => {
    const { tab = 'subscriptions' } = useFiltersFromUrl<{ tab: ISubscriptionsTab }>();
    const history = useHistory();
    const location = useLocation();

    const handleChangeTab = (selectedTab: ISubscriptionsTab) => {
        const newTab = isMobile() ? (tab === selectedTab ? 'none' : selectedTab) : selectedTab;
        changeQuery(history, location, { tab: newTab });
    };

    if (isShowcase) {
        return <NotificationsContent />;
    }

    return (
        <div className={classes.root}>
            <Tab
                className={c(classes.tab, classes.tabSubscriptions)}
                currentTab={tab}
                label="Платные подписки"
                onSelect={handleChangeTab}
                tabName="subscriptions"
            />
            <Tab
                className={c(classes.tab, classes.tabNotifications)}
                currentTab={tab}
                label="Уведомления и напоминания"
                onSelect={handleChangeTab}
                tabName="notifications"
            />
            <div className={classes.contentSubscriptions}>{tab === 'subscriptions' && <SubscriptionsContent />}</div>
            <div className={classes.contentNotifications}>{tab === 'notifications' && <NotificationsContent />}</div>
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        tab: {
            width: 50 + '%',
            boxSizing: 'border-box',
            marginBottom: 1 + 'rem',

            [theme.breakpoints.down('xs')]: {
                width: 100 + '%',
            },
        },
        contentSubscriptions: {
            width: 100 + '%',

            [theme.breakpoints.down('xs')]: {
                order: 1,
            },
        },
        contentNotifications: {
            width: 100 + '%',

            [theme.breakpoints.down('xs')]: {
                order: 3,
            },
        },
        tabSubscriptions: {
            [theme.breakpoints.down('xs')]: {
                order: 0,
            },
        },
        tabNotifications: {
            [theme.breakpoints.down('xs')]: {
                order: 2,
            },
        },
    });

export default injectSheet(styles, 'AccountSubscriptions')(Subscriptions);
